import {
  DOCUMENT_LIST,
  DOCUMENT_CREATE,
  GET_DOCUSIGN,
  DOCUMENT_TYPES,
  GET_DOC_SIGNED_URL
} from './types';

const BACKEND_API = 'BACKEND_API';

export const fetchDocuments = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_document/',
    ...DOCUMENT_LIST
  }
});

export const fetchDocumentsTypes = () => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: '/portal_document/get_types/',
    ...DOCUMENT_TYPES
  }
});

export const createDocument = data => ({
  type: BACKEND_API,
  payload: {
    method: 'post',
    url: '/portal_document/',
    data,
    ...DOCUMENT_CREATE
  }
});

export const updateDocument = (id, data) => ({
  type: BACKEND_API,
  payload: {
    method: 'patch',
    url: `/portal_document/${id}/`,
    data,
    ...DOCUMENT_CREATE
  }
});

export const getDocusign = (id, get_by=null) => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/lease_tenants/${id}/get_docusign/?${get_by ? 'get_by=' : ''}${get_by || ''}`,
    ...GET_DOCUSIGN
  }
});

export const getDocSignedUrl = id => ({
  type: BACKEND_API,
  payload: {
    method: 'get',
    url: `/lease_tenants/${id}/get_docusign_signed_url/`,
    ...GET_DOC_SIGNED_URL
  }
});
